import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  Checkbox,
  Container,
  Divider,
  Dropdown,
  Header,
  Segment,
  Table
} from 'semantic-ui-react';
import axios from 'axios';

import ChannelPoint from '../components/ChannelPoint';
import { useAuth, useError } from '../providers';

const ChannelPoints = () => {
  const [redeems, setRedeems] = useState({});
  const [commands, setCommands] = useState([]);

  const { showError } = useError();
  const { user } = useAuth();

  useEffect(() => {
    const getRedeems = async () => {
      try {
        const { data }  = await axios(
          `/api/channelpoints`,
        );
        if (data.status === 200) {
          setRedeems(data.response.redeems || []);
        }
      } catch(err) {
        showError(<center>Oops, something went wrong. Don't worry, we've been notified of the issue and will fix it as soon as possible!</center>);
      }
    }

    if (user['username']) {
      getRedeems();
    }
  }, [user, showError]);

  useEffect(() => {
    let options = [];

    const getCommands = async (user) => {
      try {
        const { data }  = await axios(
          `/api/donations/commands`,
        );
        if (data.status === 200) {
          let global = data.response.commands.filter((item) => {
            return item.source === 'global'
          })
          let custom = data.response.commands.filter((item) => {
            return item.source === 'custom'
          });

          if (custom.length) {
            options.push({
              key: 'header',
              children: () => <Dropdown.Header content="Custom Commands" />,
              disabled: true,
            })

            custom.forEach((command) => {
              options.push({
                key: command.command_name,
                value: command.command_name,
                text: command.command_name,
                placeholder: command.description,
              });
            });
          }

          if (global.length) {
            options.push({
              key: 'header',
              children: () => <Dropdown.Header content="Global Commands" />,
              disabled: true,
            })

            global.forEach((command) => {
              options.push({
                key: command.command_name,
                value: command.command_name,
                text: command.command_name,
                placeholder: command.description,
              });
            });
          }
          setCommands(options);
        }
      } catch(err) {
        showError(<center>Oops, something went wrong. Don't worry, we've been notified of the issue and will fix it as soon as possible!</center>);
      }
    }

    if (user) {
      getCommands();
    }
  }, [user, showError]);

  const toggleRedeem = (id) => async (ev, data) => {
    try {
      const { data } = await axios.post(
        '/api/channelpoints/toggle',
        { id },
      );

      if (data.status === 200) {
        setRedeems(data.response.redeems || []);
      } else {
        throw(data.response.message)
      }
    } catch(err) {
        showError(<center>Oops, something went wrong. Don't worry, we've been notified of the issue and will fix it as soon as possible!</center>);
    }
  }

  const refreshRedeems = () => {
    window.location.reload(true);
  }

  return (
    <Segment className='lobby' inverted>
      <Container text className='description'>
        <Breadcrumb size='huge'>
          <Breadcrumb.Section link as={Link} to='/dashboard'>Dashboard</Breadcrumb.Section>
          <Breadcrumb.Divider icon='right chevron' />
          <Breadcrumb.Section active>Channel Points</Breadcrumb.Section>
        </Breadcrumb>
        <Divider hidden />
        <p>
          Channel Point redeems will automatically be created on your channel for you when you login to the mod. Redeems will ignore any command settings such as when they are disabled, sub only, rate limits,
          or banned items. For example; if you banned the <strong>R Key</strong> item from being given, you could make a redeem that allows your community to activate <strong>R Key</strong> via Channel Points.
          You can use both built in, as well as <Link to='/dashboard/custom'>Custom Commands</Link> as redeem targets.
        </p>
      </Container>
      <br />
      <Table inverted singleLine striped unstackable>
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell>
              Channel Point Redeems
            </Table.HeaderCell>
            <Table.HeaderCell>
              Cost
            </Table.HeaderCell>
            <Table.HeaderCell colSpan={2}>
              Enabled
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Object.values(redeems).length === 0 ?
            <Table.Row>
              <Table.Cell>
                <Header textAlign='center' style={{'color': 'white'}}>
                  You don't have any Channel Point redeems configured yet...
                </Header>
              </Table.Cell>
            </Table.Row>
          :
            Object.values(redeems).map((redeem, index) =>
              <Table.Row key={index}>
                <Table.Cell>
                  <strong>
                    {redeem.name}
                  </strong>
                  <br />
                  {redeem.description}
                </Table.Cell>
                <Table.Cell collapsing width={2}>
                  {redeem.cost}
                </Table.Cell>
                <Table.Cell collapsing width={2}>
                  <Checkbox toggle checked={redeem.enabled} onChange={toggleRedeem(redeem.id)} />
                </Table.Cell>
                <Table.Cell collapsing>
                  <ChannelPoint redeem={redeem} refresh={refreshRedeems} commands={commands} user={user} />
                </Table.Cell>
              </Table.Row>
            )
          }
        </Table.Body>
      </Table>
      <ChannelPoint refresh={refreshRedeems} commands={commands} user={user} />
    </Segment>
  )
};

export default ChannelPoints;
